/** @format */

import { takeLeading, put, all, call, select } from 'redux-saga/effects';

import axios from 'axios';

import {
  getPairingModelAvailableModelsSuccess,
  getPairingModelAvailableModelsFailure,
  getSelectedPairingModelDataSuccess,
  getSelectedPairingModelDataFailure,
} from './pairing-model.actions';

import { selectPairingModelSelectedModel } from './pairing-model.selectors';
// import { selectCurrentUser } from '../user/user.selector';

import PairingModelActionTypes from './pairing-model.types';

export function* getAvailablePairingModels() {
  try {
    // const user = yield select(selectCurrentUser);
    const response = yield call(axios, {
      url: process.env.REACT_APP_LOCAL_URL + '/pairingModel/availableModels',
      method: 'get',
    });

    if (response.data.status === 'success') {
      yield put(getPairingModelAvailableModelsSuccess(response.data.data));
    } else {
      alert('Error getting Available Pairing Models ');
      yield put(getPairingModelAvailableModelsFailure());
    }
  } catch (error) {
    alert('Error on server while getting Available Pairing Models');
    yield put(getPairingModelAvailableModelsFailure(error));
  }
}

export function* getSelectedPairingModelData() {
  try {
    let selectedPairingModel = yield select(selectPairingModelSelectedModel);
    const response = yield call(axios, {
      url: process.env.REACT_APP_LOCAL_URL + '/pairingModel/output',
      method: 'post',
      data: {
        name: selectedPairingModel.name,
      },
    });

    if (response.data.status === 'success') {
      yield put(getSelectedPairingModelDataSuccess(response.data.data));
    } else {
      alert('Error getting Selected Pairing Model Data ');
      yield put(getSelectedPairingModelDataFailure());
    }
  } catch (error) {
    alert('Error on server while getting Selected Pairing Model Data');
    yield put(getSelectedPairingModelDataFailure(error));
  }
}

export function* onGetPairingModelsAvailableStart() {
  yield takeLeading(
    PairingModelActionTypes.GET_PAIRING_MODEL_AVAILABLE_MODELS_START,
    getAvailablePairingModels
  );
}

export function* onGetSelectedPairingModelDataStart() {
  yield takeLeading(
    PairingModelActionTypes.GET_SELECTED_PAIRING_MODEL_DATA_START,
    getSelectedPairingModelData
  );
}

export function* pairingModelSagas() {
  yield all([
    call(onGetPairingModelsAvailableStart),
    call(onGetSelectedPairingModelDataStart),
  ]);
}
